import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import clsx from 'clsx';
import { CheckIcon } from 'lucide-react';
import { Text } from './Text';

interface CheckboxProps extends CheckboxPrimitive.CheckboxProps {
  label?: string;
}

export function Checkbox({ className, label, name, ...props }: CheckboxProps) {
  return (
    <div className="gap-2xs flex items-center">
      <CheckboxPrimitive.Root
        data-slot="checkbox"
        className={clsx(
          'peer bg-base-white border-transparent-dark-16 data-[state=checked]:bg-brand-default data-[state=checked]:text-base-white data-[state=checked]:border-brand-default aria-invalid:border-error-default outline-neutral-subtle size-[18px] shrink-0 rounded-xs border shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        name={name}
        id={name}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center text-current transition-none"
        >
          <CheckIcon size={16} strokeWidth={3} />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {label && (
        <Text as="label" htmlFor={name}>
          {label}
        </Text>
      )}
    </div>
  );
}
